
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RoomFormData } from "@/types/hotel";
import { currencies } from "./constants";

interface RoomDialogPricingProps {
  formData: RoomFormData;
  setFormData: React.Dispatch<React.SetStateAction<RoomFormData>>;
}

export const RoomDialogPricing = ({ formData, setFormData }: RoomDialogPricingProps) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="space-y-2">
        <Label htmlFor="selling_price">سعر البيع</Label>
        <Input
          id="selling_price"
          type="number"
          value={formData.selling_price}
          onChange={(e) => setFormData(prev => ({ ...prev, selling_price: parseFloat(e.target.value) || 0 }))}
          placeholder="0"
          min="0"
          step="0.01"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="buying_price">سعر الشراء</Label>
        <Input
          id="buying_price"
          type="number"
          value={formData.buying_price}
          onChange={(e) => setFormData(prev => ({ ...prev, buying_price: parseFloat(e.target.value) || 0 }))}
          placeholder="0"
          min="0"
          step="0.01"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="currency">العملة</Label>
        <Select
          value={formData.currency}
          onValueChange={(value) => setFormData(prev => ({ ...prev, currency: value }))}
        >
          <SelectTrigger>
            <SelectValue placeholder="اختر العملة" />
          </SelectTrigger>
          <SelectContent>
            {currencies.map((currency) => (
              <SelectItem key={currency} value={currency}>
                {currency}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
